import React, { useEffect, useState } from 'react';
import './NeuralNexusBackground.css';

export default function NeuralNexusBackground({ opacity = 1, zIndex = 0 }) {
  const [cursor, setCursor] = useState({ x: 0.5, y: 0.5 });

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return undefined;

    let frame = null;

    function handleMove(event) {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        setCursor({
          x: event.clientX / window.innerWidth,
          y: event.clientY / window.innerHeight,
        });
        frame = null;
      });
    }

    window.addEventListener('pointermove', handleMove);
    return () => {
      window.removeEventListener('pointermove', handleMove);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <div
      className="nnb-root"
      style={{ '--nnb-x': cursor.x, '--nnb-y': cursor.y, opacity, zIndex }}
      aria-hidden="true"
    >
      <div className="nnb-nodes" />
      <div className="nnb-fibers">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
